import axios from 'axios'
import {API_URL} from '../constants';

const MASTER_API_URL = `${API_URL}/masterdata`;
const COUNTRY_API_URL = `${API_URL}/countries`;

class MasterDataService {

    retrieveAllStatus() {
        let s = localStorage.getItem("enum_status");
        if (s !== undefined && s !== null){
            return Promise.resolve(JSON.parse(s));
        }
        const token = sessionStorage.getItem('token');
        return axios.get(`${MASTER_API_URL}/getAllStatus`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            localStorage.setItem("enum_status", JSON.stringify(response.data));
            return response.data;
        }).catch(error => {
            console.log(error);
            localStorage.setItem("enum_status", '[]');
            return [];
        });
    }

    retrieveAllErrorMapping() {
        let s = localStorage.getItem("enum_error_mapping");
        if (s !== undefined && s !== null){
            return Promise.resolve(JSON.parse(s));
        }
        const token = sessionStorage.getItem('token');
        return axios.get(`${MASTER_API_URL}/getErrorMappings`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            localStorage.setItem("enum_error_mapping", JSON.stringify(response.data));
            return response.data;
        }).catch(error => {
            console.log(error);
            localStorage.setItem("enum_error_mapping", '[]');
            return [];
        });
    }

    retrieveAllErrorMappingTypes() {
        let s = localStorage.getItem("enum_error_mapping_type");
        if (s !== undefined && s !== null){
            return Promise.resolve(JSON.parse(s));
        }
        const token = sessionStorage.getItem('token');
        return axios.get(`${MASTER_API_URL}/getErrorMappingTypes`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            localStorage.setItem("enum_error_mapping_type", JSON.stringify(response.data));
            return response.data;
        }).catch(error => {
            console.log(error);
            localStorage.setItem("enum_error_mapping_type", '[]');
            return [];
        });
    }

    retrieveHolidaysOfYears() {
        const token = sessionStorage.getItem('token');
        return axios.get(`${MASTER_API_URL}/getHolidaysOfYears`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    fetchShippingCalendar (){
        const token = sessionStorage.getItem('token');
        return axios.get(`${MASTER_API_URL}/shippingCalendars/1`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    save(holiday) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${MASTER_API_URL}/save`, holiday,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    update(holiday) {
        const token = sessionStorage.getItem('token');
        return axios.put(`${MASTER_API_URL}/update`, holiday,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    delete(id) {
        const token = sessionStorage.getItem('token');
        return axios.delete(`${MASTER_API_URL}/${id}`, 
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    retrieveLogs() {
        const token = sessionStorage.getItem('token');
        return axios.get(`${MASTER_API_URL}/getLogs`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            console.log(error);
            return [];
        });
    }

    fetchDesignImages(info) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${MASTER_API_URL}/designImages`, info,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            console.log(error);
            return [];
        });
    }

    downloadImages(info){
        const token = sessionStorage.getItem('token');       
        return axios.post(`${MASTER_API_URL}/downloadImages`, info,
            { 
                headers: { 'Authorization': `Bearer ${token}` },
                responseType: 'blob' 
            }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    deleteUploadImage(id) {
        const token = sessionStorage.getItem('token');
        return axios.delete(`${MASTER_API_URL}/uploadImages/${id}`, 
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }    
    
    executeSQL(sql) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${MASTER_API_URL}/execsql`, {sql:sql},
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    retrieveFonts() {
        let s = localStorage.getItem("enum_font");
        if (s !== undefined && s !== null){
            return Promise.resolve(JSON.parse(s));
        }        
        const token = sessionStorage.getItem('token');
        return axios.get(`${MASTER_API_URL}/getFonts`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            localStorage.setItem("enum_font", JSON.stringify(response.data))
            return response.data;
        }).catch(error => {
            console.log(error);
            localStorage.setItem("enum_font", '[]')
            return [];
        });
    }

    retrieveColors() {
        let s = localStorage.getItem("enum_color");
        if (s !== undefined && s !== null){
            return Promise.resolve(JSON.parse(s));
        }

        const token = sessionStorage.getItem('token');
        return axios.get(`${MASTER_API_URL}/getColors`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            localStorage.setItem("enum_color", JSON.stringify(response.data))
            return response.data;
        }).catch(error => {
            console.log(error);
            localStorage.setItem("enum_color", '[]')
            return [];
        });
    } 

    retrieveErrorCodes() {
        let s = localStorage.getItem("enum_error_code");
        if (s !== undefined && s !== null){
            return Promise.resolve(JSON.parse(s));
        }        
        const token = sessionStorage.getItem('token');
        return axios.get(`${MASTER_API_URL}/getErrorCodes`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            localStorage.setItem("enum_error_code", JSON.stringify(response.data))
            return response.data;
        }).catch(error => {
            console.log(error);
            localStorage.setItem("enum_error_code", '[]')
            return [];
        });
    }

    retrieveShapes() {
        let s = localStorage.getItem("enum_shape");
        if (s !== undefined && s !== null){
            return Promise.resolve(JSON.parse(s));
        }         
        const token = sessionStorage.getItem('token');
        return axios.get(`${MASTER_API_URL}/getShapes`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            localStorage.setItem("enum_shape", JSON.stringify(response.data))
            return response.data;
        }).catch(error => {
            console.log(error);
            localStorage.setItem("enum_shape", '[]')
            return [];
        });
    }
    
    updateShippingCalendar(info) {
        const token = sessionStorage.getItem('token');
        return axios.put(`${MASTER_API_URL}/shippingCalendars`, info,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    retrieveCountryMappings() {
        let s = localStorage.getItem("country_mappings");
        if (s !== undefined && s !== null && s.length > 10){
            return Promise.resolve(JSON.parse(s));
        }
        const token = sessionStorage.getItem('token');
        return axios.get(`${COUNTRY_API_URL}/mappings`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            localStorage.setItem("country_mappings", JSON.stringify(response.data));
            return response.data;
        }).catch(error => {
            console.log(error);
            localStorage.setItem("country_mappings", '[]');
            return [];
        });
    }

    retrieveRegions() {
        let s = localStorage.getItem("country_regions");
        if (s !== undefined && s !== null && s.length > 10){
            return Promise.resolve(JSON.parse(s));
        }
        const token = sessionStorage.getItem('token');
        return axios.get(`${COUNTRY_API_URL}/regions`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            localStorage.setItem("country_regions", JSON.stringify(response.data));
            return response.data;
        }).catch(error => {
            console.log(error);
            localStorage.setItem("country_regions", '[]');
            return [];
        });
    }

    retrieveMappedCountries() {
        let s = localStorage.getItem("country_mappedcountries");
        if (s !== undefined && s !== null && s.length > 10){
            return Promise.resolve(JSON.parse(s));
        }
        const token = sessionStorage.getItem('token');
        return axios.get(`${COUNTRY_API_URL}/mappedcountries`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            localStorage.setItem("country_mappedcountries", JSON.stringify(response.data));
            return response.data;
        }).catch(error => {
            console.log(error);
            localStorage.setItem("country_mappedcountries", '[]');
            return [];
        });
    }

    retrieveCountryMappingsBy(code) {
        const token = sessionStorage.getItem('token');
        return axios.get(`${COUNTRY_API_URL}/mappings/${code}`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            console.log(error);
            return [];
        });
    }

    deleteCountryMapping(id) {
        const token = sessionStorage.getItem('token');
        return axios.delete(`${COUNTRY_API_URL}/mappings/${id}`, 
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    saveCountryMapping(info) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${COUNTRY_API_URL}/mappings/save`, info,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    retrieveShippingMasterErrors() {
        let s = localStorage.getItem("enum_master_error");
        if (s !== undefined && s !== null && s.trim().length > 10){
            return Promise.resolve(JSON.parse(s));
        }
        const token = sessionStorage.getItem('token');
        return axios.get(`${MASTER_API_URL}/getMasterErrorBy`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            localStorage.setItem("enum_master_error", JSON.stringify(response.data));
            return response.data;
        }).catch(error => {
            console.log(error);
            localStorage.setItem("enum_master_error", '[]');
            return [];
        });
    }

    retrieveQualityIncidents() {
        let s = localStorage.getItem("quality_incidents");
        if (s !== undefined && s !== null && s.length > 5){
            return Promise.resolve(JSON.parse(s));
        }        
        const token = sessionStorage.getItem('token');
        return axios.get(`${MASTER_API_URL}/qualityIncidents`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            localStorage.setItem("quality_incidents", JSON.stringify(response.data))
            return response.data;
        }).catch(error => {
            console.log(error);
            localStorage.setItem("quality_incidents", '[]')
            return [];
        });
    }

    retrieveQualityStatuses() {
        let s = localStorage.getItem("quality_statuses");
        if (s !== undefined && s !== null && s.length > 5){
            return Promise.resolve(JSON.parse(s));
        }        
        const token = sessionStorage.getItem('token');
        return axios.get(`${MASTER_API_URL}/qualityStatuses`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            localStorage.setItem("quality_statuses", JSON.stringify(response.data))
            return response.data;
        }).catch(error => {
            console.log(error);
            localStorage.setItem("quality_statuses", '[]')
            return [];
        });
    }

    retrieveErrorMasterDatas() {     
        const token = sessionStorage.getItem('token');
        return axios.get(`${MASTER_API_URL}/errorMasterData`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            console.log(error);
            return [];
        });
    }

    retrieveErrorUis(func) {     
        const token = sessionStorage.getItem('token');
        return axios.get(`${MASTER_API_URL}/errorUi/${func}`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            console.log(error);
            return [];
        });
    }

    retrieveErrorGroups(func) {     
        const token = sessionStorage.getItem('token');
        return axios.get(`${MASTER_API_URL}/errorUiGroups/${func}`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            console.log(error);
            return [];
        });
    }

    retrieveShippingCalendars() {     
        const token = sessionStorage.getItem('token');
        return axios.get(`${MASTER_API_URL}/shippingCalendars`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            console.log(error);
            return [];
        });
    }

    fetchPrintConfig (){
        const token = sessionStorage.getItem('token');
        return axios.post(`${MASTER_API_URL}/printConfig`, {code: sessionStorage.getItem('bcprint')},
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    fetchPrintConfigs (){
        const token = sessionStorage.getItem('token');
        return axios.get(`${MASTER_API_URL}/printConfigs`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    updatePrintConfig(info) {
        const token = sessionStorage.getItem('token');
        return axios.put(`${MASTER_API_URL}/printConfig`, info,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }
}

export default new MasterDataService()